import { req } from "./transport";

export const notificationsApi = {
  // Increment 36: web-push
  async pushVapidKey() {
    return req<{ publicKey: string; configured: boolean }>("/push/vapid-public-key");
  },

  async pushStatus() {
    return req<{ configured: boolean; count: number }>("/push/me");
  },

  async pushSubscribe(subscription: any) {
    return req<{ ok: boolean; count: number }>("/push/subscribe", { method: "POST", body: JSON.stringify({ subscription }) });
  },

  async pushUnsubscribe(endpoint: string) {
    return req<{ ok: boolean; count: number }>("/push/unsubscribe", { method: "POST", body: JSON.stringify({ endpoint }) });
  },

  async pushTest() {
    return req<{ ok: boolean; delivered: number }>("/push/test", { method: "POST" });
  },

  // Increment 13: notifications
  async getNotifications(signal?: AbortSignal) {
    return req<{ notifications: any[]; unread: number }>("/notifications", { signal }, { rejectUnauthorized: signal !== undefined });
  },

  async notifUnreadCount() {
    const r = await req<{ unread: number }>("/notifications/unread-count");
    return r?.unread ?? 0;
  },

  async markNotifRead(id: string) {
    return req<{ ok: boolean; unread: number }>(`/notifications/${encodeURIComponent(id)}/read`, { method: "POST" });
  },

  async markAllNotifRead() {
    return req<{ ok: boolean; unread: number }>("/notifications/read-all", { method: "POST" });
  }
};
